export function getAddressComponentByType(
  place: google.maps.places.PlaceResult,
  types: string[]
): google.maps.GeocoderAddressComponent | undefined {
  for (const type of types) {
    const foundComponent = place.address_components?.find((component) => component.types.includes(type));

    if (foundComponent) {
      return foundComponent;
    }
  }
}
